import { Directive, Input } from '@angular/core';

@Directive()
export class SubHeaderBaseComponent {
  @Input() icon: string;
  @Input() text: string;
}
